export const EMBED_GOOGLE_SHEET_CONFIG = {
    name        : 'Google Sheet',
    icon        : 'i5-google-sheet',
    iconSvg     : 'isvg-google-sheet',
    description : 'Embeded Google Sheet',
    embedCode   : '',
    projectIcon : 'googleSheet',                    // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['docs.google.com/spreadsheets']  // required for embedCode content search for autodetect EmbedType
}
